import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import BirthdayCard from "./BirthdayCard";
import FloatingElements from "./FloatingElements";

export default function CabinInterior() {
  return (
    <div className="absolute inset-0 cabin-bg grain overflow-hidden">
      {/* Subtle window light from left */}
      <div
        className="absolute"
        style={{
          left: "-10%",
          top: "5%",
          width: "55%",
          height: "55%",
          borderRadius: "50%",
          background:
            "radial-gradient(ellipse at center, rgba(120, 180, 255, 0.18) 0%, rgba(120, 180, 255, 0.04) 50%, transparent 75%)",
          filter: "blur(20px)",
        }}
      />

      {/* Floating hearts/flowers */}
      <FloatingElements />

      {/* Welcome aboard greeting */}
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.6, duration: 0.7 }}
        className="absolute top-6 left-0 right-0 text-center px-6 z-20"
        data-testid="welcome-banner"
      >
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#D4AF37]/40 bg-[#1A110D]/40 backdrop-blur-md">
          <Sparkles className="w-3 h-3 text-[#D4AF37]" />
          <span className="text-[10px] tracking-[0.4em] uppercase text-[#F8F5F0]/90 font-body">
            Welcome aboard, Farida
          </span>
          <Sparkles className="w-3 h-3 text-[#D4AF37]" />
        </div>
        <div className="mt-2 font-display italic text-[#F8F5F0]/60 text-xs tracking-wide">
          your private suite has been prepared
        </div>
      </motion.div>

      {/* Card scroll container — always visible behind doors */}
      <div
        className="absolute inset-0 flex items-start justify-center px-4 overflow-y-auto py-20 no-scrollbar z-10"
        style={{ touchAction: "pan-y" }}
      >
        <BirthdayCard />
      </div>

      {/* Bottom gold horizon glow */}
      <div
        className="absolute bottom-0 left-0 right-0 pointer-events-none z-0"
        style={{
          height: "30%",
          background:
            "linear-gradient(0deg, rgba(212, 175, 55, 0.18) 0%, transparent 100%)",
        }}
      />
    </div>
  );
}
